import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Mail, FileCheck, User, Clock } from "lucide-react";
import { Button } from "@akuna/ui";

export default function DataExclusion() {
  const { t } = useTranslation("dataExclusion");
  const { t: tCommon } = useTranslation("common");

  return (
    <div className="min-h-screen bg-background">
      <main className="container mx-auto px-4 py-12 max-w-4xl">
        <div className="mb-8">
          <h1 className="text-4xl font-bold text-foreground mb-2">{t("pageTitle")}</h1>
          <p className="text-muted-foreground text-lg">{t("subtitle")}</p>
        </div>

        <p className="text-foreground mb-8">{t("intro")}</p>

        <div className="space-y-8">
          <section className="rounded-lg border bg-card p-6">
            <div className="flex items-start gap-3">
              <div className="rounded-full bg-primary/10 p-2">
                <Mail className="h-5 w-5 text-primary" />
              </div>
              <div>
                <h2 className="text-xl font-bold text-foreground mb-2">{t("step1Title")}</h2>
                <p className="text-foreground">
                  {t("step1Body")}{" "}
                  <a
                    href="mailto:contato@akuna.pet"
                    className="text-primary underline font-medium"
                  >
                    {t("step1Email")}
                  </a>{" "}
                  {t("step1End")}
                </p>
              </div>
            </div>
          </section>

          <section className="rounded-lg border bg-card p-6">
            <div className="flex items-start gap-3">
              <div className="rounded-full bg-primary/10 p-2">
                <FileCheck className="h-5 w-5 text-primary" />
              </div>
              <div>
                <h2 className="text-xl font-bold text-foreground mb-2">{t("hasLoginTitle")}</h2>
                <p className="text-foreground mb-3">{t("hasLoginBody")}</p>
                <ul className="list-disc list-inside text-foreground space-y-1">
                  <li>{t("hasLoginItem1")}</li>
                  <li>{t("hasLoginItem2")}</li>
                </ul>
              </div>
            </div>
          </section>

          <section className="rounded-lg border bg-card p-6">
            <div className="flex items-start gap-3">
              <div className="rounded-full bg-primary/10 p-2">
                <User className="h-5 w-5 text-primary" />
              </div>
              <div>
                <h2 className="text-xl font-bold text-foreground mb-2">{t("isOwnerTitle")}</h2>
                <p className="text-foreground mb-3">{t("isOwnerBody")}</p>
                <ul className="list-disc list-inside text-foreground space-y-1">
                  <li>{t("isOwnerItem1")}</li>
                  <li>{t("isOwnerItem2")}</li>
                </ul>
              </div>
            </div>
          </section>

          <section className="rounded-lg border bg-primary/5 border-primary/20 p-6">
            <div className="flex items-start gap-3">
              <div className="rounded-full bg-primary/10 p-2">
                <Clock className="h-5 w-5 text-primary" />
              </div>
              <div>
                <h2 className="text-xl font-bold text-foreground mb-2">{t("deadlineTitle")}</h2>
                <p className="text-foreground">{t("deadlineBody")}</p>
              </div>
            </div>
          </section>
        </div>
      </main>

      <footer className="border-t py-8 mt-12">
        <div className="container mx-auto px-4 flex flex-col items-center gap-4">
          <Button asChild variant="outline">
            <Link to="/login">{t("backToLogin")}</Link>
          </Button>
          <p className="text-center text-sm text-muted-foreground">
            © 2026 Akuna. {tCommon("allRightsReserved")}.
          </p>
        </div>
      </footer>
    </div>
  );
}
